import { Component } from '@angular/core';
import { Cards } from '../models/Cards';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {
  stored_choices: any = {};
  product_cards:any = [];
  selected_cards:any = [];

  manual_selection:any = [];

  _selected_departments = [];
  departments = [{
    id: 1,
    label: 'OPD',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 2,
    label: 'IPD',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: false
  }, {
    id: 3,
    label: 'Day Care',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 4,
    label: 'Emergency',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 5,
    label: 'Pharmacy',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 6,
    label: 'Laboratory',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 7,
    label: 'Radiology',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 8,
    label: 'Nursing',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 9,
    label: 'Dialysis',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 10,
    label: 'EMR/Prescription',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 11,
    label: 'MRD',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }, {
    id: 12,
    label: 'Appointment',
    is_active: 0,
    parent: [1,2,3,4,5,6],
    include_clinic: true
  }];

  constructor(private cards: Cards){
    this.stored_choices = JSON.parse(localStorage.getItem('stored_choices'));

    if(this.stored_choices && this.stored_choices.selected_department){
      this.stored_choices.selected_department.forEach(element => {
        let _find = this.departments.find(f => f.id == element);

        if(_find){
          this._selected_departments.push(_find.label);
        }
      });
    }
    if(localStorage.getItem('manual_selection')){
      this.manual_selection = JSON.parse(localStorage.getItem('manual_selection'));
    } else {
      this.manual_selection = [];
    }
    
    this.product_cards = cards.cards;

    this.product_cards.forEach((card:any) => {
      if(card){
        let _check = this.checkCard(card);
        if(_check){
          card.already_selected = 1;
          this.selected_cards.push(card);
        }
        
        if(this.manual_selection && this.manual_selection.length && !card.already_selected){
          let _find = this.manual_selection.find((f:any) => f == card.id);
          if(_find){
            card.is_selected = 1;
          }
        }
      }
    });
  }

  checkCard(card){
    let show_card: boolean = false;
    let _has_setup: boolean = false;
    let _has_bed: boolean = false;
    let _has_department: boolean = false;
    if(card && this.stored_choices && this.stored_choices.selected_setup){
      if(card.parent.setup && card.parent.setup.length){
        card.parent.setup.forEach(parent => {
          if(this.stored_choices && this.stored_choices.selected_setup && parent == this.stored_choices.selected_setup.id){
            _has_setup = true;
          }
        })
      }

      if(card.parent.bed && card.parent.bed.length && (this.stored_choices.selected_setup.id == 1 || this.stored_choices.selected_setup.id == 6)){
        card.parent.bed.forEach(parent => {
          if(this.stored_choices && this.stored_choices.selected_bed && parent == this.stored_choices.selected_bed.id){
            _has_bed = true;
          }
        })
      }

      if(card.parent.department && card.parent.department.length){
        card.parent.department.forEach(parent => {
          if(this.stored_choices && this.stored_choices.selected_department ){
            let _find = this.stored_choices.selected_department.find(x => x == parent)
            if(_find){
              _has_department = true;
            }
          }
        })
      }
    }

    if(this.stored_choices){
      if(this.stored_choices.selected_setup.id == 1 || this.stored_choices.selected_setup.id == 6){
        if(_has_setup && _has_department){
          show_card = true
        }
      } else if (this.stored_choices.selected_setup.id == 2 || this.stored_choices.selected_setup.id == 3 || this.stored_choices.selected_setup.id == 4){
        if(_has_setup){
          show_card = true
        }
      } else if (this.stored_choices.selected_setup.id == 5){
        if(_has_setup && _has_department){
          show_card = true
        }
      }
    }
    return show_card;
  }

  selectCard(card){
    if(card){
      card.is_selected = !card.is_selected;

      if(card.is_selected == true){
        this.manual_selection.push(card.id);
      } else {
        this.manual_selection = this.manual_selection.filter(f => f != card.id);
      }

      if(this.manual_selection && this.manual_selection.length){
        localStorage.setItem('manual_selection', JSON.stringify(this.manual_selection));
      } else {
        localStorage.removeItem('manual_selection')
      }
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }
}
